export type TutorialStep = {
    key: string,
    target?: () => HTMLElement | null;
}

const steps: TutorialStep[] = [
    {
        key: 'introduction',
    },
    {
        key: 'prescriptions',
        target: () => document.querySelector('#prescriptionlist'),
    },
    {
        key: 'status',
        target: () => document.querySelector('#statusmonitor'),
    },
    {
        key: 'pills',
        target: () => document.querySelector('#pillstash'),
    },
    {
        key: 'pillbox',
        target: () => document.querySelector('#pillbox'),
    },
    {
        key: 'start',
        target: () => document.querySelector('#starttrigger'),
    },
    {
        key: 'diary',
        target: () => document.querySelector('#diarytrigger'),
    },
];

export default steps;
